import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { capitalize } from '@as-react/common-utils';
import { Row } from '@as/cotopaxi';
import { ProductImageSizesPortraitEnum, ProductTypes } from '@as-react/common-types';
import { memo } from 'react';
import AsNumeral from '../../../vendors/asNumeral';
import { getImageUrlForBasketTile } from '../../../util/ImageUtil';
import { ProductTileCompact } from '../../product-tile/compact/ProductTileCompact';
import { usePriceProps } from '../../../hooks/usePriceProps';
const BasketProductItemBase = ({ basketProductData, tileType, dataQA, asStatic, withOriginalSize, }) => {
    const { root, productImageConfig, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const image = getImageUrlForBasketTile(basketProductData, productImageConfig, ProductImageSizesPortraitEnum.thumb);
    const seoUrl = `${root}p${basketProductData.seoUrl}.html?colour=${basketProductData.colorId}`;
    const color = basketProductData.color ? capitalize(basketProductData.color) : '';
    const priceActual = {
        formattedPrice: AsNumeral.formatAsCurrency(basketProductData.totalPrice),
    };
    const pricePrevious = basketProductData.productHasDiscount && !!basketProductData.totalPreviousPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(basketProductData.totalPreviousPrice),
        }
        : undefined;
    const priceReference = basketProductData.productHasDiscount && !!basketProductData.lowestPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(basketProductData.lowestPrice),
        }
        : undefined;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: basketProductData.prices,
            hasDiscount: Boolean(basketProductData.productHasDiscount),
        },
        enablePriceReference: lowest_price_all,
        fallbackPriceViewModel: {
            priceActual,
            pricePrevious,
            priceReference,
        },
    });
    return (_jsx(Row, { children: _jsx(ProductTileCompact, Object.assign({ type: tileType, brand: basketProductData.brand, quantity: basketProductData.quantity, image: image, url: seoUrl, title: basketProductData.description, dataQA: dataQA, asStatic: asStatic, priceProps: priceProps }, (basketProductData.productType === ProductTypes.PRODUCT
            ? {
                sizeDescription: !withOriginalSize ? basketProductData.sizeDescription : basketProductData.originalSize,
                colorDescription: color,
            }
            : {}))) }));
};
export const BasketProductItem = memo(BasketProductItemBase);
